import { IncentiveEvaluationErrorCodes } from 'state/loyalty/hooks/types';

import { Reward } from '../types';

const HIDDEN_REWARD_ERROR_CODES = new Set<string>([
  IncentiveEvaluationErrorCodes.INVALID_STORE_ID,
  IncentiveEvaluationErrorCodes.NOT_AVAILABLE_IN_STORE,
]);

export const isRewardVisibleInBrowse = (reward: Reward): boolean =>
  !reward.errors?.some(error => HIDDEN_REWARD_ERROR_CODES.has(error.code));

/**
 * Preserve service order within each group while keeping applied rewards first and
 * rewards with service-owned availability alerts after selectable rewards.
 */
export const orderRewardsForBrowse = (
  rewards: ReadonlyArray<Reward>,
  appliedRewardIds: ReadonlySet<string>
): Reward[] =>
  rewards
    .filter(isRewardVisibleInBrowse)
    .map((reward, index) => ({ reward, index }))
    .sort((a, b) => {
      const appliedDifference =
        Number(appliedRewardIds.has(b.reward.id)) - Number(appliedRewardIds.has(a.reward.id));
      if (appliedDifference) {
        return appliedDifference;
      }

      const alertDifference =
        Number(Boolean(a.reward.inlineAlertMessage)) - Number(Boolean(b.reward.inlineAlertMessage));
      return alertDifference || a.index - b.index;
    })
    .map(({ reward }) => reward);
